'use strict';

const React = require('react');

function SignupHeader() {
    return (
        <div className="signupHeader">
            <a aria-label="Paypal" href="/" className="signupHeader-logo" />
        </div>
    );
};

module.exports = SignupHeader;



/** WEBPACK FOOTER **
 ** ./public/js/components/upgrade/SignupHeader.js
 **/